import { HIGHLIGHT_PRE, HIGHLIGHT_POST } from "./algolia-client.js";

export function escapeHtml(value) {
  return String(value == null ? "" : value).replace(
    /[&<>"']/g,
    (char) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[char]
  );
}

// Escape first, then restore only our own sentinels, so indexed content cannot inject markup.
export function highlightToHtml(value) {
  if (!value) return "";

  return escapeHtml(value)
    .split(escapeHtml(HIGHLIGHT_PRE))
    .join("<mark>")
    .split(escapeHtml(HIGHLIGHT_POST))
    .join("</mark>");
}

function highlighted(hit, attribute) {
  const result = hit && hit._highlightResult && hit._highlightResult[attribute];
  return result && result.value ? highlightToHtml(result.value) : "";
}

function snippeted(hit, attribute) {
  const result = hit && hit._snippetResult && hit._snippetResult[attribute];
  if (!result || !result.value) return "";

  const text = String(result.value).split(HIGHLIGHT_PRE).join("").split(HIGHLIGHT_POST).join("");
  return text.trim() ? highlightToHtml(result.value) : "";
}

// Splitting.js runs once at page load and never sees injected nodes, so the classes and
// --word-total/--char-total variables it wrote are stale on a clone. ids must stay unique.
export function cleanClone(node) {
  const clone = node.cloneNode(true);

  clone.querySelectorAll("[data-splitting-original], .splitting").forEach((element) => {
    element.classList.remove("splitting", "words", "chars");
    element.removeAttribute("data-splitting-original");
    element.style.removeProperty("--word-total");
    element.style.removeProperty("--char-total");
    if (!element.getAttribute("style")) element.removeAttribute("style");
  });

  if (clone.id) clone.removeAttribute("id");
  clone.querySelectorAll("[id]").forEach((element) => element.removeAttribute("id"));

  return clone;
}

export function fillCard(node, hit, { ctaLabel } = {}) {
  const typeElement = node.querySelector(".type__cta");
  if (typeElement) typeElement.textContent = hit.typeLabel || hit.category || "";

  const info = node.querySelector(".elem__open-position__info") || node;

  const titleElement = info.querySelector("h3");
  if (titleElement) {
    titleElement.innerHTML = highlighted(hit, "title") || escapeHtml(hit.title || "");
  }

  const textElement = info.querySelector("p");
  if (textElement) {
    const excerpt = snippeted(hit, "description") || snippeted(hit, "body");
    if (excerpt) textElement.innerHTML = excerpt;
    else textElement.parentNode.removeChild(textElement);
  }

  const link = node.querySelector("a.elem__button-wrap");
  if (link) {
    link.setAttribute("href", hit.url || "#");
    const linkText = link.querySelector(".elem__button-txt");
    if (ctaLabel && linkText) linkText.textContent = ctaLabel;
  }

  return node;
}

// Both surfaces host a Designer-authored .u-example block. Scope every lookup to the root
// that owns it: the navbar and the /search page each ship their own copy, and an unscoped
// document query resolves to whichever appears first in the DOM.
export function readTemplatesFrom(example) {
  if (!example) return { card: null, button: null };

  const button = Array.prototype.filter.call(example.children, (child) =>
    child.classList.contains("elem__button-wrap")
  )[0];

  return { card: example.querySelector(".search-result"), button: button || null };
}

export function readTemplates(root) {
  return readTemplatesFrom(root ? root.querySelector(".u-example") : null);
}
